import {createTheme} from '@mui/material/styles';

import {LightTheme} from '../light-theme/light-theme';
import {palette} from './palette';

export const DarkTheme = createTheme(LightTheme, {palette});
